import { render } from "./GroupSettingsPopup.vue?vue&type=template&id=31bcf024&scoped=true"
import script from "./GroupSettingsPopup.vue?vue&type=script&lang=js"
export * from "./GroupSettingsPopup.vue?vue&type=script&lang=js"

import "./GroupSettingsPopup.vue?vue&type=style&index=0&id=31bcf024&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bcf024"]])

export default __exports__